import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/location-groups')({
  component: () => <Outlet />,
});
